module.exports = __webpack_public_path__ + "img/change-bg.7a3c463c.svg";